<template>
  <div>
    <b-button 
      @click="toggleEditMode"
      v-if="!editMode && !loading && totalPS > 0"
      class="edit-button"
    >Редактировать ПС</b-button>
    <b-overlay
      :show="loading"
      rounded
      opacity="1"
      spinner-small
      spinner-variant="primary"
    >
      <div class="mt-4 pt-3" style="min-height: 400px;">
        <div v-if="editMode">
          <template v-if="availableTypes.size == 0">
            <b-jumbotron header-level="5" header="Отсутствуют типы подвижного состава" lead="Укажите у компании «Сегменты услуг», по ним мы сформируем доступные виды подвижного состава. Для указания «Сегментов» воспользуйтесь редактированием карточки компании. После это, вернитесь на данную страницу и выполните выбор.">
            </b-jumbotron>
          </template>
          <template v-if="availableTypes.size > 0">
            <b-form @submit.prevent="saveChanges">
              <b-table-simple caption-top responsive :busy="loading">
                <b-thead>
                  <b-tr>
                    <b-th class="py-3 pl-0 pr-2">Тип подвижного состава</b-th>
                    <b-th class="py-3 px-2 text-center">Общее количество</b-th>
                    <b-th class="py-3 px-2">Вид</b-th>
                    <b-th class="py-3 pl-0 pr-2 text-center">Кол-во по каждому виду</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <template v-for="category in categories" v-if="!category.hide">
                    <b-tr>
                      <b-th 
                        :rowspan="category.items.length + 1" 
                        class="py-3 pl-0 pr-2"
                        style="vertical-align: top; padding-top: 17px !important;"
                      >{{ category.category.name }}</b-th>
                      <b-th 
                        :rowspan="category.items.length + 1" 
                        class="py-3 px-2 text-center"
                        style="vertical-align: top; padding-top: 17px !important;"
                      >{{ category.total }}</b-th>
                    </b-tr>
        
                    <b-tr v-for="item in category.items" :key="item.id">
                      <b-td class="py-2 px-2">{{ item.name }} </b-td>
                      <b-td class="py-2 px-2">
                        <b-form-input
                          :key="`iq_${item.id}`"
                          placeholder="Введите количество"
                          type="number"
                          min="0"
                          max="10000"
                          size="sm"
                          v-model="itemQuantities[item.id]"
                        ></b-form-input>    
                      </b-td>
                    </b-tr>
                  </template>
                </b-tbody>
              </b-table-simple>
    
              <div class="fixed-bottom-buttons">
                <b-overlay
                :show="saving"
                rounded
                opacity="0.8"
                spinner-small
                spinner-variant="success"
                class="ml-auto"
              >
                <b-button 
                  @click="disableChanges"
                  :disabled="!editMode || saving"
                >Отменить</b-button>
          
                <b-button 
                  type="submit" 
                  variant="primary"
                  class="ml-2"
                >Сохранить</b-button>
              </b-overlay>
              </div>
            </b-form>
          </template>
        </div>
  
        <div v-else>
          <template v-if="totalPS > 0">
            <b-table-simple caption-top responsive>        
              <b-thead>
                <b-tr>
                  <b-th class="py-3 pl-0 pr-2">Тип подвижного состава</b-th>
                  <b-th class="py-3 px-2 text-center">Общее количество</b-th>
                  <b-th class="py-3 px-2">Вид</b-th>
                  <b-th class="py-3 px-2 text-center">Кол-во по каждому виду</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <template 
                  v-for="category in categories" 
                  v-if="category.total > 0"
                >
                  <b-tr>
                    <b-th 
                      :rowspan="getNotEmptyCategoryLength(category)" 
                      class="py-3 pl-0 pr-2" 
                      style="vertical-align: top; padding-top: 15px !important;"
                    >{{ category.category.name }}</b-th>
                    <b-th 
                      :rowspan="getNotEmptyCategoryLength(category)" 
                      class="py-3 px-2 text-center" 
                      style="vertical-align: top; padding-top: 15px !important;"
                    >{{ category.total }}</b-th>
                  </b-tr>
  
                  <b-tr 
                    v-for="item in category.items" 
                    :key="item.id"
                    v-if="item.quantity > 0"
                  >
                    <b-td class="py-3 px-2">{{ item.name }} </b-td>
                    <b-td class="py-3 px-2 text-center">{{ item.quantity }}</b-td>
                  </b-tr>
                </template>
              </b-tbody>
              <b-tfoot>
                <b-tr>
                  <b-td colspan="2" variant="secondary" class="py-3 px-2">
                    Всего единиц подвижного состава: <b>{{ totalPS }}</b>
                  </b-td>
                  <b-td colspan="2" variant="secondary"></b-td>
                </b-tr>
              </b-tfoot>
            </b-table-simple>
          </template>
          <template v-if="totalPS == 0 && !loading">
            <b-jumbotron header-level="5" header="Подвижной состав не зарегистрирован" lead="У компании не указано ни одной единицы подвижного состава.">
              <b-button variant="primary" @click="toggleEditMode">Заполнить данные</b-button>
            </b-jumbotron>
          </template>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { API_TRANSPORT_TYPES, API_COMPANY_TRANSPORT_TYPES } from '@/constants';

export default {
  props: {
    additionalGetParameter: { type: String, required: false, default: '' }, // If we want to add something, for example, &company_id=10
    companyId: { type: Number, required: false, default: -1 },
    services: { type: Array, required: false }
  },
  data() {
    return {
      loading: true,
      saving: false,
      notGroupedCategories: [],
      categories: {},
      editMode: false,
      itemQuantities: {},
      itemQuantitiesBackUpCopy: {},
      availableTypes: new Set()
    };
  },
  computed: {
    totalPS() {
      let total = 0;

      for(let key in this.categories) {
        total += this.categories[key].total;
      }

      return total;
    },    
  },
  watch: {
    itemQuantities: {
      handler(value) {
        this.makeCategories();
      },
      deep: true,
    },    
  },
  mounted() {
    this.prepareAvaibleTypes();
    this.loadTransportTypes();
  },
  methods: {
    prepareAvaibleTypes() {
      this.services.forEach((service) => {
        if ([994, 995, 996, 997].includes(service.id)) {
          this.availableTypes.add('FCL и LCL');
        } else if ([992, 993].includes(service.id)) {
          this.availableTypes.add('FTL и LTL');
        }
      });
    },

    loadTransportTypes() {
      api.call('get', `${API_TRANSPORT_TYPES}`).then(({data}) => {
        this.notGroupedCategories = data;
        this.loadCompanyTransportTypes();
      })
    },

    loadCompanyTransportTypes() {
      api.call('get', `${API_COMPANY_TRANSPORT_TYPES}?company_id=${this.companyId}`).then(({data}) => {
        this.itemQuantities = data;

        this.makeCategories();
        this.loading = false;
      })
    },

    makeCategories() {
      this.notGroupedCategories = this.notGroupedCategories.map(item => {
          let quantity = 0;

          if (this.itemQuantities[item.id]) {
            quantity = this.itemQuantities[item.id];
          }

          return { ...item, quantity: quantity };
        });        

        this.categories = this.groupTypes(this.notGroupedCategories);
    },

    groupTypes(items) {
      let grouped = {};

      items.forEach(element => {
        if (!grouped[element.category.name]) {
          grouped[element.category.name] = {
            items: [],
            total: 0,
            category: element.category,
            hide: !this.availableTypes.has(element.category.type)
          };
        }

        grouped[element.category.name]['items'].push(element);
        grouped[element.category.name]['total'] += Number(element.quantity);
      });

      return grouped;
    },

    toggleEditMode() {
      this.editMode = !this.editMode;

      if (this.editMode) {
        this.itemQuantitiesBackUpCopy = JSON.parse(JSON.stringify(this.itemQuantities));
      }
    },

    disableChanges() {
      this.itemQuantities = JSON.parse(JSON.stringify(this.itemQuantitiesBackUpCopy));
      this.itemQuantitiesBackUpCopy = {};
      this.toggleEditMode();
    },

    saveChanges() {
      this.saving = true;

      let items = []
      
      for (let key in this.itemQuantities) {
        items.push({
          transport_item_id: key,
          quantity: this.itemQuantities[key]
        });
      }

      api.call('post', `${API_COMPANY_TRANSPORT_TYPES}`, {
        company_id: this.companyId,
        items: items
      }).then(({data}) => {
        this.saving = false;
        this.editMode = false;
        this.itemQuantitiesBackUpCopy = {};
      })
    },

    getNotEmptyCategoryLength(category) {
      let count = 0;

      category.items.forEach((elem) => {
        if (elem.quantity > 0) {
          count++;
        }
      });

      return count + 1;
    }
  },
};
</script>
<style scoped>
  .edit-button {
    position: absolute;
    top: 12px;
    right: 21px;
  }
  .fixed-bottom-buttons {
    position: relative;
    width: 100%;
    bottom: 0;
    right: 0px;
    padding: 15px 7px 7px 25px;
    text-align: right;
    border-top: 1px solid #dbdbdb;
  }
</style>